
import React, { useState, useEffect } from "react";
import "./AdmADHOCFee.css";
import ReactPaginate from "react-paginate";
import { ApiUrl } from "../../../ApiUrl";
import { useNavigate } from "react-router-dom";

const AdmADHOCFee = () => {
  const navigate = useNavigate();
  const [isAllClassesSelected, setIsAllClassesSelected] = useState(false);
  const [isAllSectionsSelected, setIsAllSectionsSelected] = useState(false);
  const [selectedClasses, setSelectedClasses] = useState([]);
  const [classes, setClasses] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [selectedFeePeriods, setSelectedFeePeriods] = useState({});
  const [periods, setPeriods] = useState([]);
  const [isAllFeePeriodsSelected, setIsAllFeePeriodsSelected] = useState(false);
  const [isAllElementsSelected, setIsAllElementsSelected] = useState(false);
  const [selectedElements, setSelectedElements] = useState({});
  const [elements, setElements] = useState([]);
  const [amounts, setAmounts] = useState({});
  const [remarks, setRemarks] = useState({});
  const [sections, setSections] = useState([]);
  const [selectedSections, setSelectedSections] = useState({});

  const [selectedStudent, setSelectedStudent] = useState(false);
  const [students, setStudents] = useState([]); // Array to store student data
  const [isAllChecked, setIsAllChecked] = useState(false);

  const [formErrors, setFormErrors] = useState({}); // State for error messages
  const [currentPage, setCurrentPage] = useState(0);
  const studentsPerPage = 10; // Adjust this number based on your preference

  // const [students, setStudents] = useState([]);
  const [currentStudents, setCurrentStudents] = useState([]);
  // const [currentPage, setCurrentPage] = useState(0);
  // const studentsPerPage = 10;
  // const pageCount = Math.ceil(students.length / studentsPerPage);

  useEffect(() => {
    const offset = currentPage * studentsPerPage;
    setCurrentStudents(students.slice(offset, offset + studentsPerPage));
  }, [students, currentPage]);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  // const handlePageClick = (data) => {
  //   setCurrentPage(data.selected);
  // };

  // Calculate the students to display based on the current page
  const offset = currentPage * studentsPerPage;
  // const currentStudents = students.slice(offset, offset + studentsPerPage);
  const pageCount = Math.ceil(students.length / studentsPerPage);

  const handleClear = () => {
    // Resetting all states to their initial values
    setSelectedClasses({});
    setSelectedSections({});
    setSelectedFeePeriods({});
    setSelectedElements({});
    setAmounts({});
    setRemarks({});
    setIsAllClassesSelected(false);
    setIsAllSectionsSelected(false);
    setIsAllFeePeriodsSelected(false);
    setIsAllElementsSelected(false);
    setShowTable(false); // Hides the table
    setStudents([]); // Clear student data
  };

  useEffect(() => {
    fetchFeePeriods();
    fetchFeeElements();
    fetchClasses();
    fetchSections();
  }, []);

  const fetchFeePeriods = async () => {
    try {
      const response = await fetch(`${ApiUrl.apiurl}Periods/GetAllPeriods/`);
      const result = await response.json();

      if (result.message === "success") {
        const periods = result.data.map((period) => ({
          id: period.id, // Assuming each period has an 'id' property
          period_name: period.period_name,
        }));

        setPeriods(periods);

        const initialSelectedFeePeriods = {};
        periods.forEach((period) => {
          initialSelectedFeePeriods[period.id] = false; // Set initial selection state to false
        });

        setSelectedFeePeriods(initialSelectedFeePeriods);
      } else {
        console.error("Failed to fetch fee periods:", result.message);
      }
    } catch (error) {
      console.error("Error fetching fee periods:", error);
    }
  };

  const fetchFeeElements = async () => {
    try {
      const response = await fetch(
        `${ApiUrl.apiurl}FEE_ELEMENT_TYPE/GetAllFeeElements/A`
      );
      const result = await response.json();

      if (result.message === "success") {
        const elements = result.data.map((element) => ({
          id: element.id, // Assuming each element has an 'id' property
          element_name: element.element_name,
        }));

        setElements(elements);

        const initialSelectedElements = {};
        elements.forEach((element) => {
          initialSelectedElements[element.id] = false; // Set initial selection state to false
        });

        setSelectedElements(initialSelectedElements);
      } else {
        console.error("Failed to fetch fee elements:", result.message);
      }
    } catch (error) {
      console.error("Error fetching fee elements:", error);
    }
  };

  const handleAmountChange = (e, element) => {
    setAmounts({
      ...amounts,
      [element]: e.target.value,
    });
  };

  const handleRemarkChange = (e, element) => {
    setRemarks({
      ...remarks,
      [element]: e.target.value,
    });
  };

  // API call to fetch classes
  const fetchClasses = async () => {
    try {
      const response = await fetch(`${ApiUrl.apiurl}Class/GetAllClass/`);
      const result = await response.json();

      if (result.message === "Success") {
        const classes = result.data.map((classItem) => ({
          id: classItem.id,
          classname: classItem.classname,
        }));
        setClasses(classes);
        const initialSelectedClasses = {};
        classes.forEach((classItem) => {
          initialSelectedClasses[classItem.id] = false; // Set initial selection state to false
        });
        setSelectedClasses(initialSelectedClasses);
      } else {
        console.error("Failed to fetch classes:", result.message);
      }
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };

  const fetchSections = async () => {
    try {
      const response = await fetch(`${ApiUrl.apiurl}Section/GetAllSection/`);
      const result = await response.json();

      if (result.message === "Success") {
        const sections = result.data.map((section) => ({
          id: section.id,
          sectionname: section.sectionname,
        }));
        setSections(sections);
        const initialSelectedSections = {};
        sections.forEach((section) => {
          initialSelectedSections[section.id] = false; // Set initial selection state to false
        });
        setSelectedSections(initialSelectedSections);
      } else {
        console.error("Failed to fetch sections:", result.message);
      }
    } catch (error) {
      console.error("Error fetching sections:", error);
    }
  };

  // const handleSearch = async () => {
  //   const selectedClassIds = Object.keys(selectedClasses)
  //     .filter((classId) => selectedClasses[classId])
  //     .map(Number);
  //   const selectedSectionIds = Object.keys(selectedSections)
  //     .filter((sectionId) => selectedSections[sectionId])
  //     .map(Number);

  //   if (selectedClassIds.length > 0 && selectedSectionIds.length > 0) {
  //     const classId = selectedClassIds[0];
  //     const sectionId = selectedSectionIds[0];

  //     try {
  //       const response = await fetch(
  //         `${ApiUrl.apiurl}FILTER/GetstudentBasedClassSection/${classId}/${sectionId}`
  //       );

  //       if (!response.ok) {
  //         throw new Error(`HTTP error! status: ${response.status}`);
  //       }

  //       const result = await response.json();

  //       if (result.message === "Success") {
  //         console.log("Student Data:", result.data);
  //         setStudents(result.data); // Assuming result.data contains the student list
  //         setShowTable(true);
  //       } else {
  //         console.error("Failed to fetch student data:", result.message);
  //         setShowTable(false);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching student data:", error);
  //       alert(
  //         "An error occurred while fetching student data. Please try again."
  //       );
  //     }
  //   } else {
  //     setShowTable(false);
  //     alert("Please select at least one Class and Section.");
  //   }
  // };

  // const handleSearch = async () => {
  //   const selectedClassIds = Object.keys(selectedClasses)
  //     .filter((classId) => selectedClasses[classId])
  //     .map(Number);
  //   const selectedSectionIds = Object.keys(selectedSections)
  //     .filter((sectionId) => selectedSections[sectionId])
  //     .map(Number);

  //   if (selectedClassIds.length > 0 && selectedSectionIds.length > 0) {
  //     const classId = selectedClassIds[0];
  //     const sectionId = selectedSectionIds[0];

  //     try {
  //       const response = await fetch(
  //         `${ApiUrl.apiurl}FILTER/GetstudentBasedClassSection/${classId}/${sectionId}`
  //       );

  //       if (!response.ok) {
  //         throw new Error(`HTTP error! status: ${response.status}`);
  //       }

  //       const result = await response.json();

  //       if (result.message === "Success") {
  //         console.log("Student Data:", result.data);
  //         setStudents(result.data); // Assuming result.data contains the student list
  //         setShowTable(true);
  //       } else {
  //         console.error("Failed to fetch student data:", result.message);
  //         setShowTable(false);
  //       }

  //       // Clear selected fields after search operation (success or failure)
  //       setSelectedClasses({}); // Reset the selected classes
  //       setSelectedSections({}); // Reset the selected sections
  //     } catch (error) {
  //       console.error("Error fetching student data:", error);
  //       alert(
  //         "An error occurred while fetching student data. Please try again."
  //       );

  //       // Clear selected fields in case of error
  //       setSelectedClasses({}); // Reset the selected classes
  //       setSelectedSections({}); // Reset the selected sections
  //     }
  //   } else {
  //     setShowTable(false);
  //     alert("Please select at least one Class and Section.");

  //     // Clear selected fields when validation fails
  //     setSelectedClasses({}); // Reset the selected classes
  //     setSelectedSections({}); // Reset the selected sections
  //   }
  // };

  //latest code 26 may
  // const handleSearch = async () => {
  //   const selectedClassIds = Object.keys(selectedClasses)
  //     .filter((classId) => selectedClasses[classId])
  //     .map(Number);

  //   const selectedSectionIds = Object.keys(selectedSections)
  //     .filter((sectionId) => selectedSections[sectionId])
  //     .map(Number);

  //   if (selectedClassIds.length > 0 && selectedSectionIds.length > 0) {
  //     try {
  //       const response = await fetch(
  //         `${
  //           ApiUrl.apiurl
  //         }FILTER/GetstudentBasedClassSection/${selectedClassIds.join(
  //           ","
  //         )}/${selectedSectionIds.join(",")}`
  //       );

  //       if (!response.ok) {
  //         throw new Error(`HTTP error! status: ${response.status}`);
  //       }

  //       const result = await response.json();

  //       if (result.message === "Success") {
  //         console.log("Student Data:", result.data);
  //         setStudents(result.data); // Assuming result.data contains the student list
  //         setShowTable(true);
  //       } else {
  //         console.error("Failed to fetch student data:", result.message);
  //         setShowTable(false);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching student data:", error);
  //       alert(
  //         "An error occurred while fetching student data. Please try again."
  //       );
  //     }
  //   } else {
  //     setShowTable(false);
  //     alert("Please select at least one Class and Section.");
  //   }
  // };

  // const handleSearch = async () => {
  //   const selectedClassIds = Object.keys(selectedClasses)
  //     .filter((classId) => selectedClasses[classId])
  //     .map(Number);

  //   const selectedSectionIds = Object.keys(selectedSections)
  //     .filter((sectionId) => selectedSections[sectionId])
  //     .map(Number);

  //   // Get academicSessionId from localStorage
  //   const academicSessionId = localStorage.getItem("academicSessionId");

  //   if (
  //     selectedClassIds.length > 0 &&
  //     selectedSectionIds.length > 0 &&
  //     academicSessionId
  //   ) {
  //     try {
  //       const response = await fetch(
  //         `${
  //           ApiUrl.apiurl
  //         }FILTER/GetstudentBasedClassSection/${selectedClassIds.join(
  //           ","
  //         )}/${selectedSectionIds.join(",")}/${academicSessionId}`
  //       );

  //       if (!response.ok) {
  //         throw new Error(`HTTP error! status: ${response.status}`);
  //       }

  //       const result = await response.json();

  //       if (result.message === "Success") {
  //         console.log("Student Data:", result.data);
  //         setStudents(result.data); // Assuming result.data contains the student list
  //         setShowTable(true);
  //       } else {
  //         console.error("Failed to fetch student data:", result.message);
  //         setShowTable(false);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching student data:", error);
  //       alert(
  //         "An error occurred while fetching student data. Please try again."
  //       );
  //     }
  //   } else {
  //     setShowTable(false);
  //     alert(
  //       "Please select at least one Class and Section and ensure academic year is set."
  //     );
  //   }
  // };

  // const handleSearch = async () => {
  //   const selectedClassIds = Object.keys(selectedClasses)
  //     .filter((classId) => selectedClasses[classId])
  //     .map(Number);

  //   const selectedSectionIds = Object.keys(selectedSections)
  //     .filter((sectionId) => selectedSections[sectionId])
  //     .map(Number);

  //   const academicSessionId = localStorage.getItem("academicSessionId");

  //   if (
  //     selectedClassIds.length > 0 &&
  //     selectedSectionIds.length > 0 &&
  //     academicSessionId
  //   ) {
  //     try {
  //       const queryString = `academic_year_id=${academicSessionId}&classIds=${selectedClassIds.join(
  //         ","
  //       )}&sectionIds=${selectedSectionIds.join(",")}`;

  //       const response = await fetch(
  //         `${ApiUrl.apiurl}FILTER/GetstudentBasedClassSection/?${queryString}`
  //       );

  //       if (!response.ok) {
  //         throw new Error(`HTTP error! status: ${response.status}`);
  //       }

  //       const result = await response.json();

  //       if (result.message === "Success") {
  //         console.log("Student Data:", result.data);
  //         setStudents(result.data);
  //         setShowTable(true);
  //       } else {
  //         console.error("Failed to fetch student data:", result.message);
  //         setShowTable(false);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching student data:", error);
  //       alert(
  //         "An error occurred while fetching student data. Please try again."
  //       );
  //     }
  //   } else {
  //     setShowTable(false);
  //     alert(
  //       "Please select at least one Class and Section and ensure academic year is set."
  //     );
  //   }
  // };

  const handleSearch = async () => {
    const selectedClassIds = Object.keys(selectedClasses)
      .filter((classId) => selectedClasses[classId])
      .map(Number);

    const selectedSectionIds = Object.keys(selectedSections)
      .filter((sectionId) => selectedSections[sectionId])
      .map(Number);

    const academicSessionId = localStorage.getItem("academicSessionId");

    if (
      selectedClassIds.length > 0 &&
      selectedSectionIds.length > 0 &&
      academicSessionId
    ) {
      try {
        const queryString = `academic_year_id=${academicSessionId}&classIds=${selectedClassIds.join(
          ","
        )}&sectionIds=${selectedSectionIds.join(",")}`;

        const response = await fetch(
          `${ApiUrl.apiurl}FILTER/GetstudentBasedClassSection/?${queryString}`
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();

        if (result.message?.toLowerCase() === "success") {
          setStudents(result.data);
          setCurrentPage(0);
          setShowTable(true);
        } else {
          console.error("Failed to fetch student data:", result.message);
          setShowTable(false);
        }
      } catch (error) {
        console.error("Error fetching student data:", error);
        alert(
          "An error occurred while fetching student data. Please try again."
        );
      }
    } else {
      setShowTable(false);
      alert(
        "Please select at least one Class and Section and ensure academic year is set."
      );
    }
  };

  // const handleSearch = async () => {
  //   // Get selected class IDs (this will include all selected classes or none based on the Select All checkbox)
  //   const selectedClassIds = Object.keys(selectedClasses)
  //     .filter((classId) => selectedClasses[classId])
  //     .map(Number);

  //   const selectedSectionIds = Object.keys(selectedSections)
  //     .filter((sectionId) => selectedSections[sectionId])
  //     .map(Number);

  //   if (selectedClassIds.length > 0 && selectedSectionIds.length > 0) {
  //     const sectionId = selectedSectionIds[0]; // Use the first selected sectionId (assuming one section is selected)

  //     try {
  //       // If "Select All Classes" is checked, all class IDs will be sent
  //       const response = await fetch(
  //         `${
  //           ApiUrl.apiurl
  //         }FILTER/GetstudentBasedClassSection/${selectedClassIds.join(
  //           ","
  //         )}/${sectionId}`
  //       );

  //       if (!response.ok) {
  //         throw new Error(`HTTP error! status: ${response.status}`);
  //       }

  //       const result = await response.json();

  //       if (result.message === "Success") {
  //         console.log("Student Data:", result.data);
  //         setStudents(result.data); // Assuming result.data contains the student list
  //         setShowTable(true);
  //       } else {
  //         console.error("Failed to fetch student data:", result.message);
  //         setShowTable(false);
  //       }

  //       // Clear selected fields after search operation (success or failure)
  //       setSelectedClasses({}); // Reset the selected classes
  //       setSelectedSections({}); // Reset the selected sections
  //     } catch (error) {
  //       console.error("Error fetching student data:", error);
  //       alert("An error occurred while fetching student data. Please try again.");

  //       // Clear selected fields in case of error
  //       setSelectedClasses({}); // Reset the selected classes
  //       setSelectedSections({}); // Reset the selected sections
  //     }
  //   } else {
  //     setShowTable(false);
  //     alert("Please select at least one Class and Section.");

  //     // Clear selected fields when validation fails
  //     setSelectedClasses({}); // Reset the selected classes
  //     setSelectedSections({}); // Reset the selected sections
  //   }
  // };

  // const handleSearch = async () => {
  //   // Get selected class IDs (this will include all selected classes or none based on the Select All checkbox)
  //   const selectedClassIds = Object.keys(selectedClasses)
  //     .filter((classId) => selectedClasses[classId])
  //     .map(Number);

  //   const selectedSectionIds = Object.keys(selectedSections)
  //     .filter((sectionId) => selectedSections[sectionId])
  //     .map(Number);

  //   if (selectedClassIds.length > 0 && selectedSectionIds.length > 0) {
  //     // If "Select All Sections" is checked, use all section IDs
  //     try {
  //       const response = await fetch(
  //         `${
  //           ApiUrl.apiurl
  //         }FILTER/GetstudentBasedClassSection/${selectedClassIds.join(
  //           ","
  //         )}/${selectedSectionIds.join(",")}`
  //       );

  //       if (!response.ok) {
  //         throw new Error(`HTTP error! status: ${response.status}`);
  //       }

  //       const result = await response.json();

  //       if (result.message === "Success") {
  //         console.log("Student Data:", result.data);
  //         setStudents(result.data); // Assuming result.data contains the student list
  //         setShowTable(true);
  //       } else {
  //         console.error("Failed to fetch student data:", result.message);
  //         setShowTable(false);
  //       }

  //       // Clear selected fields after search operation (success or failure)
  //       setSelectedClasses({}); // Reset the selected classes
  //       setSelectedSections({}); // Reset the selected sections
  //     } catch (error) {
  //       console.error("Error fetching student data:", error);
  //       alert("An error occurred while fetching student data. Please try again.");

  //       // Clear selected fields in case of error
  //       setSelectedClasses({}); // Reset the selected classes
  //       setSelectedSections({}); // Reset the selected sections
  //     }
  //   } else {
  //     setShowTable(false);
  //     alert("Please select at least one Class and Section.");

  //     // Clear selected fields when validation fails
  //     setSelectedClasses({}); // Reset the selected classes
  //     setSelectedSections({}); // Reset the selected sections
  //   }
  // };

  // const handleClassChange = (classId) => {
  //   setSelectedClasses((prevState) => ({
  //     ...prevState,
  //     [classId]: !prevState[classId], // Toggle selected state for the given class
  //   }));
  // };

  // Handle section selection
  // Handle individual class selection change
  const handleClassChange = (classId) => {
    const updatedSelectedClasses = { ...selectedClasses };
    updatedSelectedClasses[classId] = !updatedSelectedClasses[classId]; // Toggle selection
    setSelectedClasses(updatedSelectedClasses);
  };

  const handleSectionChange = (sectionId) => {
    setSelectedSections((prevState) => ({
      ...prevState,
      [sectionId]: !prevState[sectionId], // Toggle selected state for the given section
    }));
  };

  // const handleClear = () => {
  //   console.log("Clear button clicked");
  // };

  const handleShow = () => {
    console.log("Select Student button clicked");
  };

  const handleSelectAllStudents = (event) => {
    const newChecked = event.target.checked;
    setIsAllChecked(newChecked);

    const updatedStudents = students.map((student) => ({
      ...student,
      checked: newChecked, // Set all checkboxes to the same selected state
    }));

    setStudents(updatedStudents); // Update state with the new student list
  };

  const handleCheckboxChange = (student_id) => {
    const updatedStudents = students.map(
      (students) =>
        students.student_id === student_id
          ? { ...students, checked: !students.checked } // Toggle checked state for the specific student
          : students // Keep other students unchanged
    );

    setStudents(updatedStudents); // Update the state with the modified students array
  };

  // Handle Select All for Classes
  // const handleSelectAllClasses = () => {
  //   const newValue = !isAllClassesSelected;
  //   setIsAllClassesSelected(newValue);
  //   const updatedClasses = {};
  //   classes.forEach((cls) => {
  //     updatedClasses[cls.id] = newValue; // Ensure you are using a unique identifier for classes
  //   });
  //   setSelectedClasses(updatedClasses);
  // };
  const handleSelectAllClasses = () => {
    const newValue = !isAllClassesSelected;
    setIsAllClassesSelected(newValue);
    const updatedClasses = {};
    classes.forEach((cls) => {
      updatedClasses[cls.id] = newValue; // Ensure you are using a unique identifier for classes
    });
    setSelectedClasses(updatedClasses);
  };

  // const handleSelectAllSections = () => {
  //   const newValue = !isAllSectionsSelected;
  //   setIsAllSectionsSelected(newValue);
  //   const updatedSections = {};
  //   sections.forEach((section) => {
  //     updatedSections[section.id] = newValue; // Use section.id for unique identification
  //   });
  //   setSelectedSections(updatedSections);
  // };

  const handleSelectAllSections = () => {
    const newValue = !isAllSectionsSelected;
    setIsAllSectionsSelected(newValue);
    const updatedSections = {};
    sections.forEach((section) => {
      updatedSections[section.id] = newValue; // Set all sections to selected or not
    });
    setSelectedSections(updatedSections);
  };

  // const handleSelectAllFeePeriods = () => {
  //   const newValue = !isAllFeePeriodsSelected;
  //   setIsAllFeePeriodsSelected(newValue);

  //   const updatedFeePeriods = {};
  //   periods.forEach((period) => {
  //     updatedFeePeriods[period.id] = newValue; // Use the unique identifier (id) for periods
  //   });

  //   setSelectedFeePeriods(updatedFeePeriods);
  // };

  const handleSelectAllFeePeriods = (e) => {
    // Ensure the event comes directly from the checkbox
    const newValue = e.target.checked; // Use the actual state of the checkbox
    setIsAllFeePeriodsSelected(newValue);

    const updatedFeePeriods = {};
    periods.forEach((period) => {
      updatedFeePeriods[period.id] = newValue; // Use the unique identifier (id) for periods
    });

    setSelectedFeePeriods(updatedFeePeriods);
  };

  const handleFeePeriodChange = (periodId) => {
    setSelectedFeePeriods((prevState) => ({
      ...prevState,
      [periodId]: !prevState[periodId], // Toggle selected state for the given period ID
    }));
  };

  // Handle Select All for Elements (New logic for "Element")
  const handleSelectAllElements = (e) => {
    const isSelected = e.target.checked; // Check if the "Select All" checkbox is selected or not.
    setIsAllElementsSelected(isSelected);

    // Update the selectedElements by element.id, not element_name.
    const updatedElements = elements.reduce((acc, element) => {
      acc[element.id] = isSelected; // Set the checkbox state for each element
      return acc;
    }, {});

    setSelectedElements(updatedElements); // Set the updated selection for all elements
  };

  const handleElementChange = (elementId) => {
    setSelectedElements((prevState) => ({
      ...prevState,
      [elementId]: !prevState[elementId], // Toggle the selection state for the specific element
    }));
  };

  // const handleAssign = async () => {
  //   // Check if students, fee periods, and elements are selected
  //   // const selectedStudentIds = Object.keys(students)
  //   //   .filter((student_id) => students[student_id])
  //   //   .map(Number); // Convert to numbers

  //   const selectedStudentIds = students
  //     .filter((student) => student.checked) // Filter students who are checked
  //     .map((student) => student.student_id); // Get their IDs

  //   const selectedSectionIds = Object.keys(selectedSections)
  //     .filter((sectionId) => selectedSections[sectionId])
  //     .map(Number); // Convert to numbers

  //   const selectedPeriodIds = Object.keys(selectedFeePeriods)
  //     .filter((periodName) => selectedFeePeriods[periodName])
  //     // .map(Number); // Convert to numbers
  //     .map((periodName) => parseInt(periodName, 10));

  //   // Check if the selectedPeriodIds are valid
  //   if (selectedPeriodIds.length === 0) {
  //     alert("Please select at least one fee period.");
  //     return;
  //   }

  //   // Construct the fee element data for the API request
  //   const feeElementIds = Object.keys(selectedElements)
  //     .filter((elementName) => selectedElements[elementName]) // Filter only selected elements
  //     .map((elementName) => ({
  //       element_id: parseInt(elementName, 10), // Ensure this is a valid integer
  //       amount: amounts[elementName] || 0, // Use the amount from amounts object
  //       remarks: remarks[elementName] || "", // Use the remarks from remarks object
  //     }))
  //     .filter((element) => element.element_id !== NaN); // Ensure element_id is valid
  //   //  .filter((element) => !isNaN(element.element_id));

  //   // Check if fee elements are valid
  //   if (feeElementIds.length === 0) {
  //     alert("Please select at least one fee element.");
  //     return;
  //   }

  //   const assignedData = {
  //     studentIds: selectedStudentIds, // Already converted to numbers
  //     periodIds: selectedPeriodIds, // Already converted to numbers
  //     feeElementIds: feeElementIds, // Fee elements mapped with their amounts and remarks
  //     created_by: 1, // Replace with actual user ID if needed
  //   };

  //   try {
  //     // Call the API using fetch
  //     const response = await fetch(
  //       `${ApiUrl.apiurl}ADOCH/Studentfeescreate/`,
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(assignedData),
  //       }
  //     );

  //     // Handle the response
  //     const result = await response.json();
  //     if (response.ok) {
  //       console.log("Assigned Data: ", result);
  //       alert("Data assigned successfully!");
  //       // Optionally, you can clear the selected states here if needed
  //     } else {
  //       console.error("Failed to assign data:", result);
  //       alert("Fill all the data.");
  //     }
  //   } catch (error) {
  //     console.error("Error while assigning data:", error);
  //     alert("An error occurred. Please try again.");
  //   }
  // };

  // const handleAssign = async () => {
  //   const selectedStudentIds = students
  //     .filter((student) => student.checked) // Filter students who are checked
  //     .map((student) => student.student_id); // Get their IDs

  //   const selectedSectionIds = Object.keys(selectedSections)
  //     .filter((sectionId) => selectedSections[sectionId])
  //     .map(Number); // Convert to numbers

  //   const selectedPeriodIds = Object.keys(selectedFeePeriods)
  //     .filter((periodName) => selectedFeePeriods[periodName])
  //     .map((periodName) => parseInt(periodName, 10));

  //   if (selectedPeriodIds.length === 0) {
  //     alert("Please select at least one fee period.");
  //     return;
  //   }

  //   const feeElementIds = Object.keys(selectedElements)
  //     .filter((elementName) => selectedElements[elementName])
  //     .map((elementName) => ({
  //       element_id: parseInt(elementName, 10),
  //       amount: amounts[elementName] || 0,
  //       remarks: remarks[elementName] || "",
  //     }))
  //     .filter((element) => !isNaN(element.element_id));

  //   if (feeElementIds.length === 0) {
  //     alert("Please select at least one fee element.");
  //     return;
  //   }

  //   const assignedData = {
  //     studentIds: selectedStudentIds,
  //     periodIds: selectedPeriodIds,
  //     feeElementIds: feeElementIds,
  //     created_by: 1, // Replace with actual user ID if needed
  //   };

  //   try {
  //     const response = await fetch(`${ApiUrl.apiurl}ADOCH/Studentfeescreate/`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify(assignedData),
  //     });

  //     const result = await response.json();
  //     if (response.ok) {
  //       console.log("Assigned Data: ", result);
  //       alert("Data assigned successfully!");

  //       // Clear all selected fields
  //       setStudents([]); // Clear students
  //       setSelectedSections({}); // Clear sections
  //       setSelectedFeePeriods({}); // Clear fee periods
  //       setSelectedElements({}); // Clear fee elements
  //       setAmounts({}); // Clear amounts
  //       setRemarks({}); // Clear remarks
  //     } else {
  //       console.error("Failed to assign data:", result);
  //       alert("Fill all the data.");
  //     }
  //   } catch (error) {
  //     console.error("Error while assigning data:", error);
  //     alert("An error occurred. Please try again.");
  //   }
  // };

  const handleAssign = async () => {
    const selectedStudentIds = students
      .filter((student) => student.checked) // Filter students who are checked
      .map((student) => student.student_id); // Get their IDs

    const selectedSectionIds = Object.keys(selectedSections)
      .filter((sectionId) => selectedSections[sectionId])
      .map(Number); // Convert to numbers

    const selectedPeriodIds = Object.keys(selectedFeePeriods)
      .filter((periodName) => selectedFeePeriods[periodName])
      .map((periodName) => parseInt(periodName, 10));

    const feeElementIds = Object.keys(selectedElements)
      .filter((elementName) => selectedElements[elementName])
      .map((elementName) => ({
        element_id: parseInt(elementName, 10),
        amount: amounts[elementName] || 0,
        remarks: remarks[elementName] || "",
      }))
      .filter((element) => !isNaN(element.element_id));

    // Check for missing fields and alert accordingly
    if (selectedStudentIds.length === 0) {
      alert("Please select at least one student.");
      return;
    }

    if (selectedSectionIds.length === 0) {
      alert("Please select at least one section.");
      return;
    }

    if (selectedPeriodIds.length === 0) {
      alert("Please select at least one fee period.");
      return;
    }

    if (feeElementIds.length === 0) {
      alert("Please select at least one fee element.");
      return;
    }

    // Check for missing amounts or remarks in fee elements
    for (let feeElement of feeElementIds) {
      if (feeElement.amount === 0) {
        alert("Amount is missing for the fee element.");
        return;
      }

      if (feeElement.remarks === "") {
        alert("Remarks are missing for the fee element.");
        return;
      }
    }

    const assignedData = {
      studentIds: selectedStudentIds,
      periodIds: selectedPeriodIds,
      feeElementIds: feeElementIds,
      created_by: 1, // Replace with actual user ID if needed
    };

    try {
      const response = await fetch(`${ApiUrl.apiurl}ADOCH/Studentfeescreate/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(assignedData),
      });

      const result = await response.json();
      if (response.ok) {
        console.log("Assigned Data: ", result);
        alert("Data assigned successfully!");

        // Clear all selected fields
        setStudents([]); // Clear students
        setSelectedSections({}); // Clear sections
        setSelectedFeePeriods({}); // Clear fee periods
        setSelectedElements({}); // Clear fee elements
        setAmounts({}); // Clear amounts
        setRemarks({}); // Clear remarks
      } else {
        console.error("Failed to assign data:", result);
        alert("An error occurred while assigning the data.");
      }
    } catch (error) {
      console.error("Error while assigning data:", error);
      alert("An error occurred. Please try again.");
    }
  };

  return (
    <div
      className="container-fluid"
      style={{
        border: "1px solid #ccc",
        borderRadius: "5px",
        padding: "15px",
        marginTop: "10px",
        width: "98%",
        height: "100%",
        backgroundColor: "rgba(55, 123, 241, 0.1)",
      }}
    >
      {/* Header Section */}
      <div
        className="header-container"
        style={{ textAlign: "center", marginBottom: "20px" }}
      >
        <h2 style={{ fontSize: "24px", color: "#333" }}>ADHOC FEES</h2>
      </div>

      {/* Buttons Section */}
      <div className="row mb-3 mt-3 mx-0">
        <div className="col-12 d-flex flex-wrap gap-2">
          <button
            type="button"
            className="btn btn-primary me-2"
            style={{
              width: "150px",
            }}
            onClick={handleAssign}
          >
            Assign
          </button>
          <button
            type="button"
            className="btn btn-primary me-2"
            style={{
              width: "150px",
            }}
            onClick={handleSearch}
          >
            Search
          </button>
          <button
            type="button"
            className="btn btn-primary me-2"
            style={{
              width: "150px",
            }}
            onClick={handleClear}
          >
            Clear
          </button>
          <button
            type="button"
            className="btn btn-danger me-2"
            style={{
              width: "150px",
            }}
            onClick={() => navigate("/admin/dashboard")}
          >
            Close
          </button>
        </div>
      </div>

      {/* Sections: Class, Section, Fee Period, Element */}
      <div
        className="fee-collection-container mx-2"
        style={{
          border: "1px solid #ccc",
          borderRadius: "5px",
          marginTop: "10px",
          display: "flex",
          flexWrap: "wrap",
          overflowX: "auto",
          background: "white",
        }}
      >
        {/* Class Section */}
        {/* <div
          className="fee-collection-class col-small"
          style={{ flex: "1 1 200px", margin: "10px" }}
        >
          <span>Classes</span>
          <label style={{ display: "block", marginBottom: "10px" }}>
            <input
              type="checkbox"
              checked={isAllClassesSelected}
              onChange={handleSelectAllClasses}
            />
            Select All Classes
          </label>
          <div
            className="section-content"
            style={{
              display: "flex",
              flexDirection: "column",
              maxHeight: "150px",
              overflowY: "auto",
            }}
          >
            {classes.map((cls) => (
              <div key={cls.id}>
                <input
                  type="checkbox"
                  checked={selectedClasses[cls.id] || false}
                  onChange={() => handleClassChange(cls.id)}
                />
                {cls.classname}
              </div>
            ))}
          </div>
        </div> */}

        {/* <div
          className="fee-collection-class col-small"
          style={{ flex: "1 1 200px", margin: "10px" }}
        >
          <span>Classes</span>
          <label style={{ display: "block", marginBottom: "10px" }}>
            <input
              type="checkbox"
              checked={isAllClassesSelected}
              onChange={handleSelectAllClasses}
            />
            Select All Classes
          </label>
          <div
            className="section-content"
            style={{
              display: "flex",
              flexDirection: "column",
              maxHeight: "150px",
              overflowY: "auto",
            }}
          >
            {classes.map((cls) => (
              <div key={cls.id}>
                <input
                  type="checkbox"
                  checked={selectedClasses[cls.id] || false}
                  onChange={() => handleClassChange(cls.id)}
                />
                {cls.classname}
              </div>
            ))}
          </div>
        </div> */}

        <div
          className="fee-collection-class col-small"
          style={{ flex: "1 1 200px", margin: "10px" }}
        >
          <span>Classes</span>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <input
              type="checkbox"
              id="select-all-classes"
              checked={isAllClassesSelected}
              onChange={handleSelectAllClasses}
              style={{ cursor: "pointer" }}
            />
            <label
              htmlFor="select-all-classes"
              style={{
                marginLeft: "5px",
                cursor: "pointer",
                userSelect: "none",
              }}
            >
              Select All Classes
            </label>
          </div>
          <div
            className="section-content"
            style={{
              display: "flex",
              flexDirection: "column",
              maxHeight: "150px",
              overflowY: "auto",
            }}
          >
            {classes.map((cls) => (
              <div
                key={cls.id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "5px",
                }}
              >
                <input
                  type="checkbox"
                  id={`class-${cls.id}`}
                  checked={selectedClasses[cls.id] || false}
                  onChange={() => handleClassChange(cls.id)}
                  style={{ cursor: "pointer" }}
                />
                <label
                  htmlFor={`class-${cls.id}`}
                  style={{
                    marginLeft: "5px",
                    cursor: "pointer",
                    userSelect: "none",
                  }}
                >
                  {cls.classname}
                </label>
              </div>
            ))}
          </div>
        </div>
        {/* Section Section */}
        {/* <div
          className="fee-collection-sections col-small"
          style={{ flex: "1 1 200px", margin: "10px" }}
        >
          <span>Sections</span>
          <label style={{ display: "block", marginBottom: "10px" }}>
            <input
              type="checkbox"
              checked={isAllSectionsSelected}
              onChange={handleSelectAllSections}
            />
            Select All Sections
          </label>
          <div
            className="section-content"
            style={{
              display: "flex",
              flexDirection: "column",
              maxHeight: "150px",
              overflowY: "auto",
            }}
          >
            {sections.map((section) => (
              <div key={section.id}>
                <input
                  type="checkbox"
                  checked={selectedSections[section.id] || false}
                  onChange={() => handleSectionChange(section.id)}
                />
                {section.sectionname}
              </div>
            ))}
          </div>
        </div> */}

        <div
          className="fee-collection-sections col-small"
          style={{ flex: "1 1 200px", margin: "10px" }}
        >
          <span>Sections</span>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <input
              type="checkbox"
              id="select-all-sections"
              checked={isAllSectionsSelected}
              onChange={handleSelectAllSections}
              style={{ cursor: "pointer" }}
            />
            <label
              htmlFor="select-all-sections"
              style={{
                marginLeft: "5px",
                cursor: "pointer",
                userSelect: "none",
              }}
            >
              Select All Sections
            </label>
          </div>
          <div
            className="section-content"
            style={{
              display: "flex",
              flexDirection: "column",
              maxHeight: "150px",
              overflowY: "auto",
            }}
          >
            {sections.map((section) => (
              <div
                key={section.id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "5px",
                }}
              >
                <input
                  type="checkbox"
                  id={`section-${section.id}`}
                  checked={selectedSections[section.id] || false}
                  onChange={() => handleSectionChange(section.id)}
                  style={{ cursor: "pointer" }}
                />
                <label
                  htmlFor={`section-${section.id}`}
                  style={{
                    marginLeft: "5px",
                    cursor: "pointer",
                    userSelect: "none",
                  }}
                >
                  {section.sectionname}
                </label>
              </div>
            ))}
          </div>
        </div>
        {/* Fee Period Section */}
        {/* <div
          className="fee-collection-period col-small"
          style={{ flex: "1 1 200px", margin: "10px" }}
        >
          <span>Fee Period</span>
          <label style={{ display: "block", marginBottom: "10px" }}>
            <input
              type="checkbox"
              checked={isAllFeePeriodsSelected}
              onChange={handleSelectAllFeePeriods}
            />
            Select All Fee Periods
          </label>
          <div
            className="section-content"
            style={{
              display: "flex",
              flexDirection: "column",
              maxHeight: "150px",
              overflowY: "auto",
            }}
          >
            {periods.map((period) => (
              <label key={period.id} style={{ marginBottom: "5px" }}>
                <input
                  type="checkbox"
                  checked={selectedFeePeriods[period.id] || false}
                  onChange={() => handleFeePeriodChange(period.id)}
                />
                {period.period_name}
              </label>
            ))}
          </div>
        </div> */}

        <div
          className="fee-collection-period col-small"
          style={{ flex: "1 1 200px", margin: "10px" }}
        >
          <span>Fee Period</span>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <input
              type="checkbox"
              id="select-all-fee-periods"
              checked={isAllFeePeriodsSelected}
              onChange={(e) => handleSelectAllFeePeriods(e)}
              style={{ cursor: "pointer" }}
            />
            <label
              htmlFor="select-all-fee-periods"
              style={{
                marginLeft: "5px",
                cursor: "pointer",
                userSelect: "none",
              }}
            >
              Select All Fee Periods
            </label>
          </div>
          <div
            className="section-content"
            style={{
              display: "flex",
              flexDirection: "column",
              maxHeight: "150px",
              overflowY: "auto",
            }}
          >
            {periods.map((period) => (
              <div
                key={period.id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "5px",
                }}
              >
                <input
                  type="checkbox"
                  id={`fee-period-${period.id}`}
                  checked={selectedFeePeriods[period.id] || false}
                  onChange={() => handleFeePeriodChange(period.id)}
                  style={{ cursor: "pointer" }}
                />
                <label
                  htmlFor={`fee-period-${period.id}`}
                  style={{
                    marginLeft: "5px",
                    cursor: "pointer",
                    userSelect: "none",
                  }}
                >
                  {period.period_name}
                </label>
              </div>
            ))}
          </div>
        </div>

        <div
          className="fee-collection-element col-large"
          style={{ flex: "1 1 400px", margin: "10px", overflowX: "auto" }}
        >
          <span>Element</span>
          <div className="element-content">
            <table className="table table-bordered" style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      checked={isAllElementsSelected}
                      onChange={handleSelectAllElements}
                    />
                  </th>
                  <th>Element Name</th>
                  <th>Amount</th>
                  <th>Remark</th>
                </tr>
              </thead>
              <tbody>
                {elements.map((element) => (
                  <tr key={element.id}>
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedElements[element.id] || false}
                        onChange={() => handleElementChange(element.id)}
                      />
                    </td>
                    <td>{element.element_name}</td>
                    <td>
                      <input
                        type="number"
                        value={amounts[element.id] || ""}
                        onChange={(e) => handleAmountChange(e, element.id)}
                        style={{ width: "100%" }}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={remarks[element.id] || ""}
                        onChange={(e) => handleRemarkChange(e, element.id)}
                        style={{ width: "100%" }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="col-12">
        <div className="table-responsive">
          {showTable && students.length > 0 ? (
            <table className=" table  table-bordered">
              <thead>
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      checked={isAllChecked}
                      onChange={handleSelectAllStudents}
                    />
                  </th>
                  <th>Class</th>
                  <th>Section</th>
                  <th>Name</th>
                  <th>Roll Number</th>
                  <th>Barcode</th>
                  <th>Father Name</th>
                </tr>
              </thead>
              <tbody>
                {currentStudents.map((student) => (
                  <tr key={student.student_id}>
                    <td>
                      <input
                        type="checkbox"
                        checked={student.checked || false}
                        onChange={() =>
                          handleCheckboxChange(student.student_id)
                        }
                      />
                    </td>
                    <td>{student.class_name}</td>
                    <td>{student.section_name}</td>
                    <td>{student.student_name}</td>
                    <td>{student.rollno}</td>
                    <td>{student.barcode}</td>
                    <td>{student.father_name}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            showTable && <p>No data available </p>
          )}
          <ReactPaginate
            previousLabel={"Previous"}
            nextLabel={"Next"}
            breakLabel={"..."}
            breakClassName={"page-item"}
            breakLinkClassName={"page-link"}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            containerClassName={"pagination justify-content-center"}
            pageClassName={"page-item"}
            pageLinkClassName={"page-link"}
            previousClassName={"page-item"}
            previousLinkClassName={"page-link"}
            nextClassName={"page-item"}
            nextLinkClassName={"page-link"}
            activeClassName={"active"}
          />
        </div>
      </div>
    </div>
  );
};
export default AdmADHOCFee;